import "$styles/index.css"
import "$styles/syntax-highlighting.css"

// Import all JavaScript & CSS files from src/_components
import components from "$components/**/*.{js,jsx,js.rb,css}"

import { bootstrapTheme, themeToggle } from "./dark-mode.js"
import { initMasonry } from "./masonry-init.js"
import { setupCommentLazyLoading } from "./comments-lazy-load.js"
import { initCookieConsent } from "./cookie-consent.js"
import { initTypewriter } from "./typewriter.js"

console.info("Bridgetown is loaded!")

// Navbar hamburger menu toggle + dark mode + parallax
document.addEventListener("DOMContentLoaded", function() {
  const pull = document.getElementById('pull');
  const menu = document.querySelector('.site-header nav ul');
  if (pull && menu) {
    pull.addEventListener('click', function(e) {
      e.preventDefault();
      menu.classList.toggle('hide');
    });
  }

  // Dark mode initialization and toggle
  bootstrapTheme();
  const themeToggleBtn = document.getElementById('theme-toggle');
  if (themeToggleBtn) {
    themeToggleBtn.addEventListener('click', themeToggle);
  }

  // Parallax scroll effect for main background
  window.addEventListener('scroll', function () {
    const offset = -(window.scrollY || window.pageYOffset || document.body.scrollTop) / 3;
    const main = document.getElementById('main');
    if (main) {
      main.style.backgroundPosition = '100% ' + (offset - 50) + 'px' + ', 0%, center top';
    }
  });

  // Masonry gallery initialization
  initMasonry();

  // Comment lazy loading
  setupCommentLazyLoading();

  // Cookie consent banner
  initCookieConsent();

  // Terminal typewriter effect
  initTypewriter();
});
